module.exports = __webpack_public_path__ + "static/WEDDING E&M-323-e4238369c4bd156593ab6e6641de2537.jpg";